export default "__VITE_ASSET__idHA2f8h__"